import { ReactElement } from 'react'

export const Auth0CallbackPage = (): ReactElement => {
    console.log('I am called back')
    return <div>Auth0CallbackPage</div>
}
